//External
import React, { Fragment, useEffect, useRef, useState } from "react";
import IntlTelInput from "react-intl-tel-input";
import { format } from "phone-fns";
import { useSelector } from "react-redux";
import { get_cookie } from "utils";
import fetch from "isomorphic-unfetch";
/*******************
@Purpose : Used for tell input functional
@Parameter : {className,disabled = false,fieldName,handleInputChange,isLabel = true,label,setValue,value,setNumValidation,...rest}
@Author : INIC
******************/
function TelInputFunctional({
  className,
  fieldName,
  value,
  setValue,
  setNumValidation,
  handleInputChange,
  label,
  disabled = false,
  isLabel = true,
  setcountryIso,
  country_code,
  showDropdown = false,
  contactPhoneNo,
  user,
  country,
  ...rest
}) {
  const phoneRef = useRef(null);
  const isLogout = useSelector((state) => state?.user?.isLogout);
  const [isMyInputFocused, setIsMyInputFocused] = useState(false);
  const [flag, setFlag] = useState(false);
  const [placeHolderValue, setPlaceHolderValue] = useState();
  const phoneInputId = contactPhoneNo ? "#" + contactPhoneNo : "#phone";
  const [isMobileApp, setIsMobileApp] = useState();
  const [defaultCountry, setDefaultCountry] = useState("");

  //use for fetch country code based on ip
  useEffect(() => {
    // Fetch the user's country code using ipapi
    const fetchCountryCode = async () => {
      try {
        const response = await fetch("https://ipapi.co/json/");
        if (!response.ok) {
          setDefaultCountry("us");
          throw new Error("Network response was not ok");
        }
        const data = await response?.json();
        const countryCode = data?.country_code?.toLowerCase();
        // FCR-530: react-intl-tel-input calls .focus() on the input when
        // defaultCountry changes, which scrolls the page to the form (the
        // old hack here countered that with a scroll to the top, yanking
        // the user around either way). Shadow the input's focus() with a
        // no-op for the duration of the update so the focus-steal — and
        // therefore any scrolling — never happens at all.
        const phone = document.getElementById(
          contactPhoneNo ? contactPhoneNo : "phone"
        );
        if (phone) {
          phone.focus = () => {};
        }
        setDefaultCountry(countryCode ?? "us");
        setTimeout(() => {
          if (phone) {
            delete phone.focus; // restore the native focus method
            phone.blur();
          }
        }, 0);
      } catch (error) {
        console.error("Error fetching country code:", error);
      }
    };

    fetchCountryCode();
  }, []);

  useEffect(() => {
    if (user && !user.country_shortname && !flag) {
      setTimeout(async () => {
        if (value && value.includes("+")) {
          var b = value.split(" ");
          var c = b.splice(1);
          var d = c.join(" ");
          await setFlag(true);
          await setValue(d);
          await setPlaceHolderValue(d);
          setTimeout(() => {
            const phone = document.getElementById(
              contactPhoneNo ? contactPhoneNo : "phone"
            );
            if (phone) {
              phone.blur();
            }
          }, 500);
        }
      }, 100);
    }
  }, [user, value, flag]);

  const handlePhoneNumberChange = async (
    isValid,
    rawValue,
    countryData
    // extension
  ) => {
    if (phoneRef?.current) {
      const { placeholder } = phoneRef?.current?.state;
      let placeholderData = placeholder ? placeholder : placeHolderValue;
      let canGoAhead = false;
      let phoneNumber = "";
      let placeholderNumber = "";

      if (!rawValue.length) {
        setValue("");
        handleInputChange("", countryData, false);
      }

      if (
        placeholderData &&
        placeholderData?.length &&
        rawValue &&
        rawValue?.length
      ) {
        placeholderNumber = placeholderData.match(/\d/g);
        placeholderNumber = placeholderNumber.join("");

        phoneNumber = rawValue.match(/\d/g);
        phoneNumber = (phoneNumber && phoneNumber.join("")) || "";

        if (placeholderNumber.length >= phoneNumber.length) {
          canGoAhead = true;
        }
      }

      if (canGoAhead) {
        const formatedPlaceholder = placeholderData.replace(/[0-9]/g, "N");
        let result = format(formatedPlaceholder, phoneNumber);
        result = result && result.replace(/N/g, "");
        if (result[0] === "0") {
          result = result.slice(1);
        }

        if (
          placeholderNumber.length === phoneNumber.length &&
          placeholderNumber[0] === "0" &&
          phoneNumber[0] !== "0"
        ) {
          if (placeholderNumber.length === phoneNumber.length) {
            await handleInputChange(value, countryData, true);
            await setNumValidation({
              valid: true,
              error: "",
            });
            setValue(value);
            setCaretPosition();
          } else {
            setValue("" + result.slice(0, -1) || "");
            handleInputChange(
              "" + result.slice(0, -1) || "",
              countryData,
              true
            );
          }
        } else if (placeholderNumber.length >= phoneNumber.length) {
          setValue(result || "");
          handleInputChange(result || "", countryData, isValid);
        }
      }
    }
  };

  const handleNumberFormat = (rawValueData, placeholderData) => {
    if (rawValueData) {
      let phoneNumber = rawValueData.match(/\d/g);
      phoneNumber[0] = phoneNumber[0] === "0" ? "" : phoneNumber[0];
      phoneNumber = phoneNumber.join("");

      let placeholderNumber = placeholderData.match(/\d/g);
      placeholderNumber = placeholderNumber?.join("");

      if (placeholderNumber?.length >= phoneNumber.length) {
        const formatedPlaceholder = placeholderData.replace(/[0-9]/g, "N");

        if (placeholderData[0] === "0" && rawValueData[0] !== "0") {
          phoneNumber = "0" + phoneNumber;
        }

        // if (placeholderNumber.length > phoneNumber.length) {
        //   phoneNumber =
        //     phoneNumber +
        //     '0'.repeat(placeholderNumber.length - phoneNumber.length);
        // }

        const result = format(formatedPlaceholder, phoneNumber).replaceAll(
          "N",
          ""
        );
        setValue(result);
      }
    } else {
      setValue("");
    }
  };

  const setCaretPosition = () => {
    const elem = document.querySelector(phoneInputId);
    if (elem) {
      elem.focus();
      elem.setSelectionRange(value.length, value.length);
      elem.focus();
    }
  };

  const handleSelectFlag = () => {
    // setcountryIso(defaultCountry);
    setcountryIso && setcountryIso(phoneRef.current.selectedCountryData.iso2);
    setValue("");
    setNumValidation({
      valid: false,
      error: "",
    });
    const input = document.querySelector(phoneInputId);
    input.focus();

    setTimeout(() => {
      const placeHolderVal = phoneRef?.current?.state?.placeholder;
      commonSetPlaceHolderValue(placeHolderVal);
    }, 500);

    /*
    setTimeout(() => {
      if (phoneRef?.current?.state && isLogout) {
        const { placeholder } = phoneRef?.current?.state;
        handleNumberFormat(value, placeholder);
        const input = document.querySelector(phoneInputId);
        input.focus();
        setCaretPosition();
      }
    }, 500);
    */
  };

  const commonSetPlaceHolderValue = (placeHolderVal) => {
    let placeHolderFinalVal = placeHolderVal;
    if (placeHolderVal?.["0"] === "0") {
      placeHolderFinalVal = placeHolderVal?.slice(1);
    }
    setPlaceHolderValue(placeHolderFinalVal);
  };

  const phoneNumberFocusHandler = () => {
    const placeHolderVal = phoneRef?.current?.state?.placeholder;
    commonSetPlaceHolderValue(placeHolderVal);
  };

  useEffect(() => {
    setIsMobileApp(get_cookie("is_mobile_app"));
  }, []);

  return (
    <Fragment>
      {isLabel && (
        <label
          className={`floating-label ${
            isMyInputFocused || value ? "active" : ""
          }`}
          htmlFor="contact_number"
        >
          {label}
        </label>
      )}
      <IntlTelInput
        placeholder={placeHolderValue}
        defaultCountry={country || defaultCountry}
        ref={phoneRef}
        containerClassName={`${
          disabled ? "allow-dropdown " : ""
        }intl-tel-input phone-input ${
          isMobileApp === "yes" ? "phone-arrow" : ""
        }`}
        css={["intl-tel-input", "form-control", className]}
        onPhoneNumberChange={handlePhoneNumberChange}
        onPhoneNumberBlur={(isValid) => {
          if (value) {
            setNumValidation({
              valid: isValid,
              error: !isValid ? "Please enter a valid phone number" : "",
            });
          }
          setIsMyInputFocused(false);
        }}
        onSelectFlag={handleSelectFlag}
        value={value}
        format
        inputClassName={className}
        formatOnInit
        fieldName={contactPhoneNo ? contactPhoneNo : "phone"}
        fieldId={contactPhoneNo ? contactPhoneNo : "phone"}
        allowDropdown={disabled ? false : true}
        disabled={disabled}
        onPhoneNumberFocus={() => {
          setIsMyInputFocused(true);
          phoneNumberFocusHandler();
        }}
        {...rest}
      />
    </Fragment>
  );
}

export default TelInputFunctional;
